export default __webpack_public_path__ + "static/media/img-thumb-jogo-boom.42728535.jpg";